import React from 'react';
import { AiFillGithub, AiFillLinkedin } from 'react-icons/ai';
import { FaEnvelope, FaInstagram } from 'react-icons/fa';

const socials = [
  { icon: <AiFillGithub size={18} />, href: 'https://github.com/Balaji2810', label: 'GitHub' },
  { icon: <FaInstagram size={18} />, href: 'https://www.instagram.com/balaji.official/', label: 'Instagram' },
  { icon: <FaEnvelope size={18} />, href: 'mailto:bstudies28@gmail.com', label: 'Email' },
  { icon: <AiFillLinkedin size={18} />, href: 'https://www.linkedin.com/in/balaji-j-6725b2311/', label: 'LinkedIn' },
];

export default function NewFooter() {
  return (
    <footer
      style={{
        borderTop: '1px solid rgba(255, 255, 255, 0.04)',
        padding: '3rem 2rem',
        maxWidth: '1200px',
        margin: '0 auto',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '1.5rem',
        }}
      >
        <div>
          <div
            style={{
              fontFamily: "'Space Grotesk', sans-serif",
              fontSize: '1.1rem',
              fontWeight: 700,
              color: '#ffffff',
              marginBottom: '0.5rem',
            }}
          >
            <span style={{ color: '#00ff88' }}>B</span>alaji
            <span style={{ color: '#00ff88' }}>.</span>
          </div>
          <div style={{ fontSize: '0.8rem', color: '#555' }}>
            Backend Developer & Tech Lead
          </div>
        </div>

        <div style={{ display: 'flex', gap: '0.75rem' }}>
          {socials.map((social) => (
            <a
              key={social.label}
              href={social.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={social.label}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '40px',
                height: '40px',
                borderRadius: '8px',
                border: '1px solid rgba(255, 255, 255, 0.08)',
                color: '#888',
                transition: 'all 0.2s ease',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = 'rgba(0, 255, 136, 0.3)';
                e.currentTarget.style.color = '#00ff88';
                e.currentTarget.style.transform = 'translateY(-2px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.08)';
                e.currentTarget.style.color = '#888';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
            >
              {social.icon}
            </a>
          ))}
        </div>
      </div>

      <div
        style={{
          marginTop: '2rem',
          paddingTop: '1.5rem',
          borderTop: '1px solid rgba(255, 255, 255, 0.03)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '0.5rem',
        }}
      >
        {/* <div style={{ fontSize: '0.75rem', color: '#444' }}>
          Designed & built by Balaji J
        </div> */}
        <div style={{ fontSize: '0.75rem', color: '#444' }}>
          © {new Date().getFullYear()}
        </div>
      </div>
    </footer>
  );
}